import React from 'react';
import {Modal,Flex} from 'antd-mobile';
import Iconfont from "../../components/Iconfont/Iconfont";



class OrganizerModal extends React.Component {
    constructor(props) {
        console.log(props)
        super(props);
        this.state = {

        }
    }
    componentDidMount() {

    }


    render() {

        return (
            <Modal
                className={'quesfill-modal'}
                visible={true}
                transparent
                closable={false}
                maskClosable={true}
                onClose={this.props.hide}


            >
                <div style={{color:'#FD7926',textAlign:'center'}}>
                    <Flex justify={'start'} style={{fontSize:14,lineHeight:'45px',backgroundColor:'#eee',color:'#959595',padding:'0 16px'}}>
                        <Iconfont style={{ color: '#B49F7A'}} libname="ckicon" type="zuzhijiagou-"/>
                        <span style={{marginLeft:6}}>组织机构</span>
                    </Flex>
                    <div style={{padding:'0 16px'}}>
                        {this.props.data.organizers && this.props.data.organizers.length > 0 &&
                        <Flex className='organizer-modal-item' justify={'start'} align={'start'} >
                            <span style={{color:'#39C5C1'}}>主办方：</span>
                            <div>
                                {this.props.data.organizers.map((o,index)=><p key={index}>{o}</p>)}
                            </div>
                        </Flex>}
                        {this.props.data.collaborators && this.props.data.collaborators.length !=0 ?
                            <Flex className='organizer-modal-item' justify={'start'} align={'start'} >
                                <span style={{color:'#39C5C1'}}>协办方：</span>
                                <div>
                                    {this.props.data.collaborators && this.props.data.collaborators.map((o,index)=><p key={index}>{o}</p>)}
                                </div>
                            </Flex> : ''}

                        {this.props.data.contractors && this.props.data.contractors.length !=0 ?
                            <Flex className='organizer-modal-item' justify={'start'} align={'start'} >
                                <span style={{color:'#39C5C1'}}>承办方：</span>
                                <div>
                                    {this.props.data.contractors && this.props.data.contractors.map((o,index)=><p key={index}>{o}</p>)}
                                </div>
                            </Flex> : ''}
                        {this.props.data.customOrganizer &&
                            JSON.parse(this.props.data.customOrganizer).map((obj,index)=>(
                                <Flex key={index} className='organizer-modal-item' justify={'start'} align={'start'} >
                                    <span style={{color:'#39C5C1',maxWidth:110,flexShrink:0}}>{obj.name}：</span>
                                    <div>
                                        {
                                            obj.value.indexOf(',') > -1 ?
                                                obj.value.split(',').map((v,vindex)=>(<p key={vindex}>{v}</p>))
                                                :
                                                obj.value.split('，').map((v,vindex)=>(<p key={vindex}>{v}</p>))
                                        }
                                    </div>
                                </Flex>
                            ))
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}


export default OrganizerModal;



// WEBPACK FOOTER //
// ./src/containers/invitation-page/OrganizerModal.jsx